/* eslint-disable no-console */
import { type Dispatch } from 'redux';
import get from 'lodash.get';
import * as actions from './actions';
import { ERROR_MESSAGES } from '../constants';
import AccountApi from '../../../shared/apis/AccountApi';
import ErrorToast from '../../../shared/components/Toasts/ErrorToast';

const INTERNAL_SERVER_ERROR_STATUS = 500;

export const fetchFinancingTerms = () => (dispatch: Dispatch) => {
  dispatch(actions.fetchFinancingTermsBegin());
  return AccountApi.getFinancingTerms()
    .then((response) => {
      dispatch(actions.fetchFinancingTermsSuccess(response.data));
    })
    .catch((error) => {
      console.error(error);
      dispatch(actions.fetchFinancingTermsFailure(error));

      const isInternalServerError = get(error, 'response.status') === INTERNAL_SERVER_ERROR_STATUS;
      const errorToastMessage = isInternalServerError
        ? ERROR_MESSAGES.GET_FINANCING_TERMS
        : ERROR_MESSAGES.GET_FINANCING_TERMS_TIMEOUT;
      ErrorToast(errorToastMessage);
    });
};

export const fetchTermsOverview = () => (dispatch: Dispatch) => {
  dispatch(actions.fetchTermsOverviewBegin());

  return AccountApi.getFinancingTermsOverview()
    .then((response) => {
      dispatch(actions.fetchTermsOverviewSuccess(response.data));
    })
    .catch((error) => {
      console.error(error);
      dispatch(actions.fetchTermsOverviewFailure(error));
      const isInternalServerError = get(error, 'response.status') === INTERNAL_SERVER_ERROR_STATUS;
      const errorToastMessage = isInternalServerError
        ? ERROR_MESSAGES.GET_FINANCING_TERMS
        : ERROR_MESSAGES.GET_FINANCING_TERMS_TIMEOUT;
      ErrorToast(errorToastMessage);
    });
};

export const postToggleCoApplicant = () => (dispatch: Dispatch) => {
  dispatch(actions.fetchTermsOverviewBegin());

  dispatch(actions.toggleCoApplicantStatusSuccess());

  return AccountApi.setToggleCoApplicant()
    .then((response) => {
      dispatch(actions.fetchTermsOverviewSuccess(response.data));
    })
    .catch((error) => {
      console.error(error);
      dispatch(actions.fetchTermsOverviewFailure(error));
      const isInternalServerError = get(error, 'response.status') === INTERNAL_SERVER_ERROR_STATUS;
      const errorToastMessage = isInternalServerError
        ? ERROR_MESSAGES.GET_FINANCING_TERMS
        : ERROR_MESSAGES.GET_FINANCING_TERMS_TIMEOUT;
      ErrorToast(errorToastMessage);
    });
};
